import React from 'react';
import { useNavigate } from 'react-router-dom';
import NuvvyDrinkExperience from '../../../../../../components/NuvvyDrinkExperience';
import { approveDrink, makeDrink } from '../../../../../../services/Clint/AiAgentApi';

const Makedrinkpage = () => {
  const navigate = useNavigate();

  return (
    <NuvvyDrinkExperience
      makeDrinkRequest={makeDrink}
      approveDrinkRequest={approveDrink}
      backPath="/makeorder"
      approvedNavigatePath="/makeorder"
      approveSource="local_screen"
      title="إنشاء مشروبك الخاص"
      subtitle="خلّي Nuvvy يساعدك تصمم مشروب على مزاجك"
      onNavigate={navigate}
    />
  );
};

export default Makedrinkpage;
